// @ts-ignore
export default '0.0.1'
